<template>
  <div>
    <mobialis-form-with-validation @onValidate="continueForm">
      <div :class="{ 'row justify-content-between': showBlocks }">
        <div :class="{ 'col-sm-7': showBlocks }">
          <Hero :title="$t('message.insurance.hero.personalForm')" :text="weValuePrivacyText"></Hero>
          <mobialis-text-input-with-validation
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.firstName')"
            v-model="firstName"
            vid="firstName"
            data-cy="firstName"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.lastName')"
            v-model="lastName"
            vid="lastName"
            data-cy="lastName"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            rules="required|length:10"
            :label="$t('message.common.mobileNumber')"
            v-model="phoneNumber"
            vid="phoneNumber"
            placeholder="(   )"
            mask-type="phoneNumber"
            type="tel"
            data-cy="phoneNumber"
            :error-message="avErrors['phoneNumber']"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            rules="required|email"
            :label="$t('message.common.emailAddress')"
            v-model="emailAddress"
            vid="emailAddress"
            data-cy="emailAddress"
            type="email"
            :error-message="avErrors['emailAddress']"
          ></mobialis-text-input-with-validation>
          <mobialis-check-box-with-validation
            rules="required:true"
            :label="termsText"
            vid="tandc"
            id="tandc"
            data-cy="tAndC"
          ></mobialis-check-box-with-validation>
        </div>
        <div v-if="showBlocks" class="col-sm-4 d-none d-sm-block">
          <DisclaimerCard
            class="card border-0 shadow mb-2"
            :iconSrc="require('@/assets/hammer.svg')"
            :title="$t('message.insurance.disclaimer.firstCardTitle')"
            :text="$t('message.insurance.disclaimer.firstCardText')"
            :text-left-space="false"
          ></DisclaimerCard>
          <DisclaimerCard
            class="card border-0 shadow mb-2"
            :iconSrc="require('@/assets/star.svg')"
            :title="$t('message.insurance.disclaimer.secondCardTitle')"
            :text="`${businessName} ${$t('message.insurance.disclaimer.secondCardText')}`"
            :text-left-space="false"
          ></DisclaimerCard>
        </div>
      </div>
      <mobialis-button type="submit" class="mt-5" data-cy="submit">{{ $t('message.common.continue') }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { avErrorMixin } from '@/mixins';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import log from '@/services/log';
import Hero from './hero/Hero.vue';

export default {
  name: 'PersonalForm',
  data() {
    return {};
  },
  mixins: [avErrorMixin],
  mounted() {
    this.$store.commit('SET_LOADING', false);
  },
  components: { Hero, DisclaimerCard },
  computed: {
    ...mapGetters('business', ['getBusinessName', 'getPhoneNumberVerificationArray', 'getThisIsAmerica']),
    businessName() {
      return this.getBusinessName;
    },
    weValuePrivacyText() {
      return this.isAVRDesktop ? this.$t('message.hero.weValuePrivacy') : null;
    },
    termsText() {
      return this.$t('message.insurance.formCheckBox', { link: this.termsLink, dealer: this.getBusinessName });
    },
    termsLink() {
      return this.$t('message.insurance.formLink');
    },
    showBlocks() {
      return this.$route.meta.showBlocks;
    },
    firstName: {
      get() {
        return this.$store.state.user.firstName;
      },
      set(value) {
        this.$store.commit('user/SET_FIRST_NAME', value);
      },
    },
    lastName: {
      get() {
        return this.$store.state.user.lastName;
      },
      set(value) {
        this.$store.commit('user/SET_LAST_NAME', value);
      },
    },
    emailAddress: {
      get() {
        return this.$store.state.user.emailAddress;
      },
      set(value) {
        this.$store.commit('user/SET_EMAIL_ADDRESS', value);
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.user.phoneNumber;
      },
      set(value) {
        this.$store.commit('user/SET_PHONE_NUMBER', value);
      },
    },
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead');
        await this.$store.dispatch('lead/updateLead');

        // Do mobile verification if enabled
        if (this.getPhoneNumberVerificationArray.insurance) {
          this.$router.push({ name: `insurance-mobile-verification-${this.baseRoute}` });
        } else {
          // Navigate to Home address page for US flow
          if (this.getThisIsAmerica) {
            this.$router.push({ name: `home-address-${this.baseRoute}` });
            return;
          }
          this.$router.push({ name: `additional-questions-${this.baseRoute}` });
        }
      } catch (err) {
        if (!this.handleServerSideError(err)) {
          log('Error in Insurance Personal Form - Create/Update Lead', err);
          this.$router.push({ name: `insurance-error-${this.baseRoute}` });
        }
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
